<template>
    <div class='tag-section' :class="{'read-list-mode': readMode}">
        <ul class='row l-reset tag-list'>
            <li v-for="tag in list" :key="tag" class='tag-list-item'>
                {{ tag }}
                <button
                    v-if="!readMode"
                    @click="() => handleUpdateTag('remove', tag)"
                >
                    x
                </button>
            </li>
        </ul>
        <div class='row c-v add-tag-container' v-if="!readMode">
            <input
                type='text' 
                class='form-field' 
                :value="tagField"
                @input="(e) => updateTagField(e.target.value)"
            />
            <button
                class='btn green'
                :disabled="tagField.replace(/ /g, '') === ''"
                @click="() => handleUpdateTag('add', tagField)"
            >
                Add
            </button>
        </div>
     </div>
</template>

<script>
export default {
    props: ['list', 'onUpdateTag', 'readMode'],
    data: () => ({
        tagField: ''
    }),
    methods: {
        updateTagField (v) { this.tagField = v },
        handleUpdateTag (action, tag) {
            if (action === 'add') {
                if (!this.list.includes(tag)) {
                    this.onUpdateTag(action, tag)
                }
                this.tagField = ''
            } else {
                this.onUpdateTag(action, tag)
            }
        }
    }
}
</script>

<style lang='scss'>
.tag-section {
  & .tag-list {
    flex-wrap: wrap;
    & > li.tag-list-item {
      margin: 4px 4px 12px 4px;
      border-radius: 6px;
      padding: 3px 4px;
      background-color: #e9e9e9;
      align-item: center;
      color: #333;
      button {
        padding: 1px 4px;
        border-radius: 50%;
        background-color: pink;
        color: red;
        margin-left: 4px;
        transition: all .2s;
        &:hover {
          color: #fff;
          background-color: red;
        }
      }
    }
  }
  .add-tag-container {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    input[type=text] {
      width: calc(97% - 100px);
    }
    button {
      padding: 10px 10px;
      width: 80px;
    }
  }
  &.read-list-mode{
      & .tag-list {
          padding: 0;
          margin: 0;
          li.tag-list-item {
              padding: 1px 3px;
              margin: 0 3px 3px 0;
          }
      }
  }
}
</style>